/**
 * @packageDocumentation
 * @module      AssociationState.ts
 * @description Provides convenient ways of accessing the association state.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
export default class AssociationState {
    /**
     * Return the state string in a friendlier form.
     *
     * @param stateString One of the values from the association_states table in the database, or the empty string.
     */
    static getFriendlyName(stateString) {
        switch (stateString) {
            case 'ASSOCIATED':
                return "Associated";
            case 'ASSOCIATION_PENDING':
                return "Association Pending";
            case 'ASSOCIATION_REJECTED':
                return "Association Rejected";
            case 'ASSOCIATION_REQUEST_CANCELED':
                return "Assoc Request Canceled";
            case 'NONE':
                return "None";
            case '':
                return "";
            default:
                return "Unknown State";
        }
    }
}
//# sourceMappingURL=AssociationState.js.map